import { render, staticRenderFns } from "./nasatv-schedule.vue?vue&type=template&id=f0908ed8"
import script from "./nasatv-schedule.vue?vue&type=script&lang=ts&setup=true"
export * from "./nasatv-schedule.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports